import { render } from "./LocationSvg.vue?vue&type=template&id=df3e7aa6"
import script from "./LocationSvg.vue?vue&type=script&lang=ts"
export * from "./LocationSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script